import React, { useEffect, useState } from "react";

// Importar o sistema de temas
import { 
  getCurrentTheme, 
  getCampaignText, 
  isThemedMonth, 
  ThemeConfig 
} from '../../config/themeConfig';

interface FooterProps {
  version?: string;
}

const Footer: React.FC<FooterProps> = ({ version = "Ver. 2.1.2" }) => {
  const [, setIp] = useState<string>("");
  
  // Usar o sistema de temas
  const currentTheme: ThemeConfig = getCurrentTheme();
  const campaign = getCampaignText(currentTheme);
  const isThemed = isThemedMonth();

  // Configurações de cores baseadas no tema
  const getThemeConfig = () => {
    switch (currentTheme.theme) {
      case 'pink':
        return {
          bgColor: 'bg-pink-600',
          textColor: 'text-white',
          accentColor: 'text-pink-200',
          label: 'Conscientização'
        };
      case 'blue':
        return {
          bgColor: 'bg-blue-700',
          textColor: 'text-white',
          accentColor: 'text-blue-200',
          label: 'Prevenção'
        };
      case 'yellow':
        return {
          bgColor: 'bg-yellow-500',
          textColor: 'text-white',
          accentColor: 'text-yellow-200',
          label: 'Valorização'
        };
      case 'red':
        return {
          bgColor: 'bg-red-600',
          textColor: 'text-white',
          accentColor: 'text-red-200',
          label: 'Celebração'
        };
      case 'green':
        return {
          bgColor: 'bg-green-600',
          textColor: 'text-white',
          accentColor: 'text-green-200',
          label: 'Celebração'
        };
      default:
        return {
          bgColor: 'bg-blue-800',
          textColor: 'text-white',
          accentColor: 'text-blue-200',
          label: 'Sistema'
        };
    }
  };

  const themeConfig = getThemeConfig();

  useEffect(() => {
    const fetchIp = async () => {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        setIp(data.ip);
      } catch (error) {
        console.error("Erro ao obter o IP", error);
      }
    };

    fetchIp();
  }, []);

  // Se não for tema especial, retorna o layout padrão original
  if (!isThemed) {
    return (
      <footer className="bg-blue-800 text-white text-xs flex justify-between items-center px-6 py-2">
        <span className="flex-1 text-left">
          {/* Espaço reservado para conteúdo esquerdo */}
        </span>
        
        <span className="flex-1 text-center">
          ® Todos os direitos reservados a AFRAFEP Saúde
        </span>
        
        <span className="flex-1 text-right">
          {version}
        </span>
      </footer>
    );
  }

  return (
    <footer className={`${themeConfig.bgColor} ${themeConfig.textColor} text-xs flex flex-col sm:flex-row justify-between items-center px-6 py-3 gap-2 transition-colors duration-300`}>
      
      {/* Versão do sistema - Esquerda */}
      <span className={`${themeConfig.accentColor} font-medium`}>
        {version}
      </span>

      {/* Mensagem central - Campanha */}
      <span className="text-center font-medium">
        <span className="flex items-center gap-2">
          {currentTheme.decorations.emoji}
          {campaign.subtitle}
          {currentTheme.decorations.emoji}
        </span>
      </span>

      {/* Informações adicionais - Direita */}
      <span className={`${themeConfig.accentColor} text-xs`}>
        <span className="flex items-center gap-1">
          {currentTheme.decorations.icon}
          <span className="hidden sm:inline">
            {themeConfig.label}
          </span>
        </span>
      </span>
    </footer>
  );
};

export default Footer;